/**
 * @description Canonical public-site URLs for SEO and absolute links.
 * @filename site-urls.ts
 */

export const CANONICAL_ORIGIN = "https://www.radivision.com";

export const CANONICAL_HOMEPAGE_URL = `${CANONICAL_ORIGIN}/`;

export const OG_IMAGE_URL = `${CANONICAL_ORIGIN}/og-share.png`;
